import React, {Component} from 'react';
import {Button, Modal} from 'react-bootstrap';
import axios from 'axios';
import Select from 'react-select';
import {cloneDeep, isNumber} from 'lodash';
import Utils from '../Utils';
import ErrorMessageContainer from '../ErrorMessageContainer';
import {commaDecimalToFloat} from '../utils/number';
import {isNullOrUndefined} from '../utils/general';

const dropdownValues = [
    {value: 'true', label: window.__js_general.success},
    {value: 'false', label: window.__js_general.failure},
];

const parseData = (data) => {
    const newData = cloneDeep(data);

    let isPassed = null;

    switch (data.is_passed) {
        case true:
            isPassed = 'true';
            break;
        case false:
            isPassed = 'false';
            break;
    }

    if (isPassed) {
        isPassed = dropdownValues.find((item) => item.value === isPassed) || null;
    }

    newData.is_passed = isPassed;

    let grade = null;

    if (isNumber(data.grade)) {
        grade = data.grade + '';
        grade = grade.replace('.', ',');
    }

    newData.grade = grade;

    let sustainabilityScore = null;

    if (isNumber(data.sustainability_score)) {
        sustainabilityScore = data.sustainability_score + '';
        sustainabilityScore = sustainabilityScore.replace('.', ',');
    }

    newData.sustainability_score = sustainabilityScore;

    return newData;
}

const preparePayload = (data) => {
    let isPassed = null;

    if (data.is_passed && data.is_passed.value) {
        switch (data.is_passed.value) {
            case 'true':
                isPassed = true;
                break;
            case 'false':
                isPassed = false;
                break;
        }
    }

    let {
        grade,
        review_service: reviewService,
        sustainability_score: sustainabilityScore
    } = data;

    grade = commaDecimalToFloat(grade);
    sustainabilityScore = commaDecimalToFloat(sustainabilityScore);

    const formData = new FormData();

    formData.append('is_passed', isNullOrUndefined(isPassed) ? '' : (isPassed + ''));
    formData.append('grade', isNullOrUndefined(grade) ? '' : (grade + ''));
    formData.append('review_service', isNullOrUndefined(reviewService) ? '' : (reviewService + ''));
    formData.append('sustainability_score', isNullOrUndefined(sustainabilityScore) ? '' : (sustainabilityScore + ''));

    return formData;
}

export default class SupplierReviewModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: {},
            errors: [],
        };

        this.fetchData = this.fetchData.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getEndpoint = this.getEndpoint.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.show) {
            return;
        }

        this.setState({loading: true}, () => {
            this
                .fetchData()
                .then((data) => {
                    const {review} = data;

                    this.setState({
                        loading: false,
                        data: parseData(review),
                    });
                });
        });
    }

    getEndpoint() {
        return `/suppliers/review/${this.props.supplierId}`;
    }

    fetchData() {
        const promises = [
            axios.get(this.getEndpoint()),
        ];

        return axios
            .all(promises)
            .then((responses) => {
                const review = responses[0].data;

                return {
                    review: review.review || {},
                };
            });
    }

    onSave() {
        const endpoint = this.getEndpoint();

        const payload = preparePayload(this.state.data);

        this.setState({loading: true, errors: []}, () => {
            axios
                .post(endpoint, payload, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(() => {
                    location.reload();
                })
                .catch((failure) => {
                    this.setState({
                        errors: failure.response.data,
                        loading: false,
                    });
                });
        });
    }

    onChange(key, value) {
        const newData = cloneDeep(this.state.data);

        if (key === 'grade' || key === 'sustainability_score') {
            value = Utils.handleDecimals(value);
        }

        newData[key] = value;

        this.setState({data: newData});
    }

    render() {
        const {show, onClose} = this.props;

        return (
            <Modal show={show} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_bid_reviews.supplier_review}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorMessageContainer errors={this.state.errors}/>

                    <form>
                        <div className="form-group">
                            <label htmlFor="is_passed">{window.__js_bid_reviews.review_results}</label>
                            <Select name="is_passed"
                                    id="is_passed"
                                    clearable={true}
                                    value={this.state.data.is_passed || null}
                                    options={dropdownValues}
                                    onChange={(value) => this.onChange('is_passed', value)}
                                    placeholder={window.__js_general.choose_literal}>
                            </Select>
                        </div>
                        <hr/>
                        <div className="form-group">
                            <label htmlFor="is_passed">{window.__js_bid_reviews.review_grade}</label>
                            <input type="text"
                                   name="grade"
                                   id="grade"
                                   className="form-control"
                                   value={this.state.data.grade || ''}
                                   onChange={(e) => this.onChange('grade', e.target.value)}/>
                            <span className="help-block">
                                {window.__js_bid_reviews.comma_helper}
                            </span>
                        </div>
                        <hr/>
                        <div className="form-group">
                            <label htmlFor="is_passed">{window.__js_bid_reviews.review_service}</label>
                            <input type="text"
                                   name="review_service"
                                   id="review_service"
                                   className="form-control"
                                   value={this.state.data.review_service || ''}
                                   onChange={(e) => this.onChange('review_service', e.target.value)}/>
                        </div>
                        <hr/>
                        <div className="form-group">
                            <label htmlFor="is_passed">Sustainability Score</label>
                            <input type="text"
                                   name="sustainability_score"
                                   id="sustainability_score"
                                   className="form-control"
                                   value={this.state.data.sustainability_score || ''}
                                   onChange={(e) => this.onChange('sustainability_score', e.target.value)}/>
                            <span className="help-block">
                                {window.__js_bid_reviews.comma_helper}
                            </span>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onClose}>
                        {window.__js_general.close}
                    </Button>
                    <Button onClick={this.onSave}
                            bsStyle="primary"
                            disabled={this.state.loading}>
                        {window.__js_general.save}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}